module.exports = __webpack_public_path__ + "img/8D.fcafeaf2.png";